(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-quantity"] && !Shopify.designMode) return;
  try {
    (()=>{
    // Keep dialog and message in sync when the selected variant changes
    // The PDP renders this block twice (desktop + mobile), so update every copy
    document.addEventListener('theme:variant:change', (e) => {
      const variant = e.detail?.variant;
      if (!variant) return;

      const hasBackorder = variant.inventory_management
        && variant.inventory_policy !== 'deny'
        && variant.inventory_quantity > 0;

      document.querySelectorAll('.backorder-dialog').forEach((dialog) => {
        dialog.dataset.variantId = variant.id;
        dialog.dataset.inventoryPolicy = variant.inventory_policy || '';
        // Use a huge sentinel for deny-policy variants so the backorder path never triggers
        dialog.dataset.availableQuantity = hasBackorder
          ? variant.inventory_quantity
          : Number.MAX_SAFE_INTEGER;
        // Clear any previous message for deny-policy variants (will be set by addToCartError)
        const msgEl = dialog.querySelector('[data-dialog-message]');
        if (msgEl && !hasBackorder) msgEl.textContent = '';
      });

      document.querySelectorAll('.backorder-over-limit').forEach((message) => {
        if (!hasBackorder) {
          message.hidden = true;
          message.dataset.limit = Number.MAX_SAFE_INTEGER;
        } else {
          message.dataset.limit = variant.inventory_quantity;
          // Re-evaluate the currently selected quantity against the new limit
          const checked = message.parentElement.querySelector('[name="quantity"]:checked');
          message.hidden = !checked || Number(checked.value) <= variant.inventory_quantity;
        }
      });
    });

    // Show backorder dialog when added qty exceeds available stock (the copy visible at this breakpoint)
    document.addEventListener('theme:cart:just_added', (e) => {
      const dialog = [...document.querySelectorAll('.backorder-dialog')].find((d) => d.parentElement.checkVisibility());
      if (!dialog) return;
      if (String(dialog.dataset.variantId) !== String(e.detail.variant_id)) return;
      if (e.detail.quantity <= Number(dialog.dataset.availableQuantity)) return;
      dialog.showModal();
    });
  })()
  } catch(e) { console.error(e); }
})();

})();
